
import React from 'react';
import { SplitRequest } from '../types';
import Logo, { CleroS } from './Logo';

interface Props {
  request: SplitRequest;
  onGoToSession: () => void;
  onBackToHome: () => void;
}

const CleroConfirmed: React.FC<Props> = ({ request, onGoToSession, onBackToHome }) => {
  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center p-6 text-center animate-in fade-in duration-700">
      <div className="mb-12">
        <button
          onClick={onBackToHome}
          className="text-gray-400 hover:text-black transition-colors flex items-center space-x-2 text-sm font-medium"
        >
          <i className="fas fa-chevron-left text-[10px]"></i>
          <span>Return to Listing</span>
        </button>
      </div>

      <div className="mb-10 p-2">
        <CleroS size={64} className="text-black" />
      </div>

      <h1 className="text-4xl font-semibold text-gray-900 tracking-tight mb-4">Clero active</h1>
      <p className="text-lg text-gray-500 font-normal max-w-lg mb-12 leading-relaxed">
        Everything is set. We've sent the payment links to your group. You can now relax while we handle the collection.
      </p>

      <div className="w-full max-w-sm space-y-4">
        <button
          onClick={onGoToSession}
          className="w-full bg-black text-white py-4 rounded-2xl font-medium text-lg hover:opacity-90 transition-all shadow-sm"
        >
          Track progress
        </button>
        <div className="flex justify-center mt-4">
          <Logo size="sm" className="opacity-40" />
        </div>
      </div>

      <div className="mt-24 flex items-center space-x-3 text-gray-100">
        <i className="fas fa-shield-check text-base"></i>
        <span className="text-[9px] font-semibold uppercase tracking-[0.2em] text-gray-300">Clero GroupLock™ Technology</span>
      </div>
    </div>
  );
};

export default CleroConfirmed;
